<div class="spinner" *ngIf="this.cm.isLoading | async">
    <mat-spinner [diameter]="33"></mat-spinner>
</div>
<router-outlet></router-outlet>